export enum Chat {
  Alberta,
  PatientApp,
}
